import axios from "axios";

function getOpenApiBaseUrl(): string {
  const env = process.env.REACT_APP_ENV;
  if (env === "development") {
    return process.env.REACT_APP_DEV_API_URL || "";
  }
  if (env === "staging") {
    return process.env.REACT_APP_STAGING_API_URL || "";
  }
  if (env === "production") {
    return process.env.REACT_APP_PROD_API_URL || "";
  }
  return (
    process.env.REACT_APP_STAGING_API_URL ||
    process.env.REACT_APP_DEV_API_URL ||
    ""
  );
}

function extractDeliveryNumber(data: unknown): string | null {
  if (data == null || typeof data !== "object") return null;
  const d = data as Record<string, unknown>;
  const direct = d.delivery_number;
  if (typeof direct === "string" && direct.length > 0) return direct;
  const nested = d.data;
  if (nested != null && typeof nested === "object") {
    const inner = (nested as Record<string, unknown>).delivery_number;
    if (typeof inner === "string" && inner.length > 0) return inner;
  }
  return null;
}

export async function fetchDeliveryLocationForm(encryptedToken: string): Promise<{
  delivery_number: string;
  raw: unknown;
}> {
  const base = getOpenApiBaseUrl();
  const { data } = await axios.get(`${base}/open/delivery/location-form`, {
    params: { encrypted_token: encryptedToken },
  });
  const delivery_number = extractDeliveryNumber(data);
  if (!delivery_number) {
    throw new Error("Invalid response: missing delivery_number");
  }
  return { delivery_number, raw: data };
}

export async function submitDeliveryLocationForm(body: {
  delivery_number: string;
  latitude: string;
  longitude: string;
}): Promise<unknown> {
  const base = getOpenApiBaseUrl();
  const { data } = await axios.post(
    `${base}/open/delivery/location-form-submit`,
    body,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return data;
}
